import { alpha, styled } from '@mui/material/styles'

export interface LabelProps {
  color?: 'primary' | 'secondary' | 'error' | 'success' | 'warning' | 'info'
}

const Label = styled('span', {
  shouldForwardProp: (prop) => prop !== 'color' && prop !== 'sx',
  name: 'Label',
  slot: 'Root',
})<LabelProps>(({ theme, color = 'primary' }) => ({
  fontFamily: theme.typography.fontFamily,
  alignItems: 'center',
  borderRadius: 2,
  display: 'inline-flex',
  flexGrow: 0,
  whiteSpace: 'nowrap',
  cursor: 'default',
  flexShrink: 0,
  fontSize: theme.typography.pxToRem(12),
  fontWeight: theme.typography.fontWeightMedium,
  height: 20,
  justifyContent: 'center',
  letterSpacing: 0.5,
  minWidth: 20,
  padding: theme.spacing(0.5, 1),
  textTransform: 'uppercase',
  color: theme.palette[color] && theme.palette[color].main,
  backgroundColor: theme.palette[color] && alpha(theme.palette[color].main, 0.08),
}))

export default Label
